import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthAPI } from '../services/api';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await AuthAPI.forgotPassword(email);
      setSubmitted(true);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card-header">
          <img src="/logo.png" alt="KeeDocs" className="auth-logo" />
          <h2>Forgot your password?</h2>
          <p>Enter your email and we'll send you a reset link</p>
        </div>

        <div className="auth-card-body">
          {submitted ? (
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <div style={{ fontSize: '3rem', marginBottom: 16 }}>📬</div>
              <h3 style={{ marginBottom: 8 }}>Check your inbox</h3>
              <p className="text-muted" style={{ marginBottom: 24 }}>
                If <strong>{email}</strong> is registered, you'll receive a reset link shortly. Check your spam folder if you don't see it.
              </p>
              <Link to="/login" className="btn btn-primary w-100">Back to Sign In</Link>
            </div>
          ) : (
            <>
              {error && (
                <div className="alert alert-error">{error}</div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email" className="form-label">Email address</label>
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    disabled={loading}
                    placeholder="you@example.com"
                    autoFocus
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading || !email}
                >
                  {loading ? 'Sending…' : 'Send Reset Link'}
                </button>
              </form>
              <div className="auth-footer">
                <Link to="/login">← Back to Sign In</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
